import { render } from "./taxCategoriesEditor.vue?vue&type=template&id=548b14e0"
import script from "./taxCategoriesEditor.vue?vue&type=script&lang=js"
export * from "./taxCategoriesEditor.vue?vue&type=script&lang=js"

import exportComponent from "/home/adachi/omega-base/omega/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__